(function() {
  function bindCartDrawerClose() {
    const closeBtn = document.querySelector('.drawer__close-btn[aria-controls="CartDrawer"]');
    const cartDrawer = document.getElementById('CartDrawer');
    
    if (closeBtn && cartDrawer) {
      // Alten Listener entfernen und neu binden
      const newBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newBtn, closeBtn);
      
      newBtn.addEventListener('click', function() {
        cartDrawer.removeAttribute('open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
      });
    }
  }

  // Nach jedem BOGOS/Cart-Update neu binden
  document.addEventListener('cart:refresh', bindCartDrawerClose);
  document.addEventListener('cart:updated', bindCartDrawerClose);
  
  // Auch auf Section-Renders reagieren
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        bindCartDrawerClose();
      }
    });
  });
  
  const drawerContent = document.querySelector('[id^="CartDrawer-sections-"]');
  if (drawerContent) {
    observer.observe(drawerContent, { childList: true, subtree: false });
  }
})();